import { render, staticRenderFns } from "./CustomerPrices.vue?vue&type=template&id=a8ff7f0c"
import script from "./CustomerPrices.vue?vue&type=script&lang=js"
export * from "./CustomerPrices.vue?vue&type=script&lang=js"
import style0 from "./CustomerPrices.vue?vue&type=style&index=0&id=a8ff7f0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports